import type { Dayjs } from "dayjs";
import React from "react";
import TextField from "@mui/material/TextField";
import styles from "./date-picker.module.scss";
import classnames from "classnames";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export type DatePickerProps = {
  value: Dayjs | null;
  disabled?: boolean;
  onChange: (date: Dayjs | null, keyboardInputValue?: string) => void;
  darkMode?: boolean;
};

export const DatePicker: React.FC<DatePickerProps> = ({ disabled, value, onChange, darkMode }) => {
  return (
    <span className={classnames(styles.datePicker, { [styles.darkMode]: darkMode })}>
      <MuiDatePicker<Dayjs>
        disabled={disabled}
        value={value}
        onChange={(date, keyboardInput) => {
          if (!keyboardInput && !date?.isValid()) {
            onChange(date, keyboardInput);
          }
          const timeNow = dayjs().format("HH:mm");
          onChange(dayjs(`${date?.format("YYYY-MM-DD")} ${timeNow}`, "YYYY-MM-DD HH:mm"), keyboardInput);
        }}
        renderInput={(params) => <TextField {...params} />}
      />
    </span>
  );
};
